import { createRouter, createWebHashHistory } from "vue-router";
import Home from "@/views/Home";
import Notfound from "@/views/Notfound";
import NoPermission from "@/views/Nopermission";
import Login from "@/views/Login";
import Index from "@views/HomePage";
import Recognition from "@views/HelpBeforeArrival";
import Navigation from "@views/Navigation";
import Guiding from "@/views/Guiding";
import SmartLive from "@views/SmartLive";
import Event from "@views/EventManage";
import Setting from "@views/UserSetting";
import SettingSchedule from "@views/SettingSchedule";
import ShowAmbulance from "@views/AmbulanceLive";
import ShowAmbulance2 from "@views/AmbulanceLive/ShowAmbulance2";
import ShowPatient from "@/components/PatientPages/ShowPatient";
import ShowPatientSmart from "@/components/PatientPages/ShowPatientSmart";
import AddPatient from "@/components/PatientPages/AddPatients";
import AddPatientSmart from "@/components/PatientPages/AddPatientsSmart";
import CleanMode from "@/views/CleanMode";
// import Fullscreen from "@/views/Fullscreen";
import Map from "@/views/map";
import Link from "@/views/Link";
import Introduction from "@/components/headers/Introduction";
// 测试使用
// import ShowPatientB from "@/components/PatientPages/ShowPatientB";
// import AddPatientB from "@/components/PatientPages/AddPatientsB";

const routes = [
  {
    path: "/",
    redirect: "/HelpBeforeArrival",
    meta: {
      title: "院前急救 首页",
      roles: ["admin", "user"]
    }
  },

  {
    // 测试用
    path: "/test",
    component: Map,
    meta: {
      title: "测试",
      roles: ["admin", "user"]
    }
  },
  {
    path: "/link/:url",
    component: Link,
    meta: {
      title: "跳转到微信小程序",
      roles: ["admin", "user"]
    }
  },
  {
    // 登录界面
    path: "/login",
    component: Login,
    meta: {
      title: "院前急救 登陆",
      roles: ["admin", "user"]
    }
  },
  // {
  //   // 车前急救
  //   path: "/contact",
  //   component: Home,
  //   // redirect: '/contact',
  //   children: [
  //     {
  //       path: "/contact",
  //       component: Contact,
  //       name: "Contact"
  //     }
  //   ]
  // },
  {
    // 急救车实况
    path: "/index",
    component: Home,
    // redirect: '/HelpBeforeArrival',
    children: [
      {
        path: "/index",
        component: Index,
        name: "Index"
      }
    ],
    meta: {
      title: "院前急救 首页",
      roles: ["admin", "user"]
    }
  },
  {
    // 急救车展示
    path: "/showAmbulance",
    component: Home,
    // redirect: '/showAmbulance',
    children: [
      {
        path: "/showAmbulance/:id",
        component: ShowAmbulance,
        name: "ShowAmbulance"
      }
    ],
    meta: {
      title: "急救车-急救实况",
      roles: ["admin", "user"]
    }
  },
  {
    // 急救车展示
    path: "/showAmbulance2",
    component: Home,
    children: [
      {
        path: "/showAmbulance2/:id",
        component: ShowAmbulance2,
        name: "ShowAmbulance2"
      }
    ],
    meta: {
      title: "院前急救 急救车展示",
      roles: ["admin", "user"]
    }
  },
  {
    // 语音识别
    path: "/HelpBeforeArrival",
    component: Home,
    // redirect: '/HelpBeforeArrival',
    children: [
      {
        path: "/HelpBeforeArrival/:id",
        component: Recognition,
        name: "Recognition"
      }
    ],
    meta: {
      title: "急救车-车前急救",
      roles: ["admin", "user"]
    }
  },
  {
    // 导航
    path: "/Navigation",
    component: Home,
    children: [
      {
        path: "/Navigation/:id",
        component: Navigation,
        name: "navigation"
      }
    ],
    meta: {
      title: "急救车-导航",
      roles: ["admin", "user"]
    }
  },
  {
    // 急救指引
    path: "/guiding",
    component: Home,
    children: [
      {
        // path: "/guiding/:id",
        path: "/guiding",
        component: Guiding,
        name: "guiding"
      }
    ],
    meta: {
      title: "急救指引",
      roles: ["admin", "user"]
    }
  },
  {
    // 无人车导航
    path: "/planeNavigation",
    component: Home,
    children: [
      {
        path: "/planeNavigation/:id",
        component: Navigation,
        name: "planeNavigation"
      }
    ],
    meta: {
      title: "无人机-导航定位",
      roles: ["admin", "user"]
    }
  },
  {
    // 无人车导航
    path: "/autoMobileNavigation",
    component: Home,
    children: [
      {
        path: "/autoMobileNavigation/:id",
        component: Navigation,
        name: "Navigation"
      }
    ],
    meta: {
      title: "无人车-导航定位",
      roles: ["admin", "user"]
    }
  },
  {
    // 无人车实况
    path: "/autoMobileLive",
    component: Home,
    children: [
      {
        path: "/autoMobileLive/:id",
        component: SmartLive,
        name: "autoMobileLive"
      }
    ],
    meta: {
      title: "无人车-急救实况",
      roles: ["admin", "user"]
    }
  },
  {
    // 无人车实况
    path: "/planeLive",
    component: Home,
    children: [
      {
        path: "/planeLive/:id",
        component: SmartLive,
        name: "planeLive"
      }
    ],
    meta: {
      title: "无人机-急救实况",
      roles: ["admin", "user"]
    }
  },
  {
    // 查看具体病例
    path: "/showPatient",
    component: Home,
    redirect: "/showPatient",
    children: [
      {
        path: "/showPatient/:id",
        component: ShowPatient,
        name: "showPatient"
      }
    ],
    meta: {
      title: "院前急救 事例查看",
      roles: ["admin", "user"]
    }
  },
  {
    // 查看具体病例
    path: "/ShowPatientSmart",
    component: Home,
    redirect: "/ShowPatientSmart",
    children: [
      {
        path: "/ShowPatientSmart/:id",
        component: ShowPatientSmart,
        name: "ShowPatientSmart"
      }
    ],
    meta: {
      title: "院前急救 事例查看",
      roles: ["admin", "user"]
    }
  },
  {
    // 添加病例
    path: "/addPatient",
    component: Home,
    redirect: "/addPatient",
    children: [
      {
        path: "/addPatient/:id",
        component: AddPatient,
        name: "addPatient"
      }
    ],
    meta: {
      title: "院前急救 编辑事例",
      roles: ["admin", "user"]
    }
  },
  {
    // 添加病例
    path: "/addPatientSmart",
    component: Home,
    redirect: "/addPatientSmart",
    children: [
      {
        path: "/addPatientSmart/:id",
        component: AddPatientSmart,
        name: "addPatientSmart"
      }
    ],
    meta: {
      title: "院前急救 编辑事例",
      roles: ["admin", "user"]
    }
  },

  {
    // 添加病例
    path: "/writeMore",
    component: Home,
    children: [
      {
        path: "/writeMore/:id/add",
        component: AddPatient,
        name: "writeMore"
      }
    ],
    meta: {
      title: "院前急救 补写事例",
      roles: ["admin", "user"]
    }
  },
  {
    // 添加病例
    path: "/writeMoreSmart",
    component: Home,
    children: [
      {
        path: "/writeMoreSmart/:id/add",
        component: AddPatientSmart,
        name: "writeMoreSmart"
      }
    ],
    meta: {
      title: "院前急救 补写事例",
      roles: ["admin", "user"]
    }
  },

  {
    // 事件管理
    path: "/isShowManageCase",
    component: Home,
    redirect: "/event",
    children: [
      {
        path: "/isShowManageCase",
        component: Event,
        name: "event"
      }
    ],
    meta: {
      title: "信息管理-急救事例",
      roles: ["admin", "user"]
    }
  },
  {
    // 查找
    path: "/setting",
    component: Home,
    redirect: "/setting",
    children: [
      {
        path: "/setting",
        component: Setting,
        name: "setting"
      }
    ],
    meta: {
      title: "设置 - 用户管理",
      roles: ["admin"]
    }
  },
  {
    // 查找
    path: "/settingSchedule",
    component: Home,
    children: [
      {
        path: "/settingSchedule",
        component: SettingSchedule,
        name: "SettingSchedule"
      }
    ],
    meta: {
      title: "设置-排班设置",
      roles: ["admin"]
    }
  },
  {
    // 纯净模式
    path: "/cleanMode",
    component: Home,
    children: [
      {
        path: "/cleanMode/:id",
        component: CleanMode,
        name: "CleanMode"
      }
    ]
  },
  // {
  //   // 全屏模式
  //   path: "/fullscreen/:id",
  //   component: Fullscreen
  // },
  {
    // 帮助页面
    path: "/help",
    component: Home,
    children: [
      {
        path: "/help",
        component: Introduction,
        name: "Introduction"
      }
    ],
    meta: {
      title: "院前急救 网站简介",
      roles: ["admin", "user"]
    }
  },

  {
    path: "/404",
    component: Home,
    children: [
      {
        path: "/404",
        component: Notfound,
        name: "404"
      }
    ],
    meta: {
      title: "院前急救 页面不存在404",
      roles: ["admin", "user"]
    }
  },
  {
    path: "/no-permission",
    component: Home,
    children: [
      {
        path: "/no-permission",
        component: NoPermission,
        name: "NoPermission"
      }
    ],
    meta: {
      title: "无权访问403",
      roles: ["admin", "user"]
    }
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/404"
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});
const defaultTitle = "5G急救车系统";

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  const { title } = to.meta;
  document.title = title || defaultTitle;
  if (to.path.startsWith("/link")) {
    next();
  } else if (to.path === "/login") {
    next();
  } else {
    // let token = Cookies.get("token");
    const token = sessionStorage.getItem("token");
    if (token == null || token === "") {
      next("/login");
    } else {
      next();
    }
  }
});

export default router;
